// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-hotel-with-attractions__attractions{max-width:600px;margin-right:auto;margin-left:auto}.h-hotel-with-attractions-list--dense-attractions .h-hotel-with-attractions__attractions{max-width:none}", ""]);
// Exports
module.exports = exports;
